import { useAppSelector } from 'store'

import { hasPermission, selectEmail, selectUser, selectUserFirstName, selectUserLastName, selectUserScid } from '.'

export const useUser = () => useAppSelector(selectUser)
export const useCanTestApp = () => useAppSelector((state) => hasPermission(state, 'TEST_COLLEGE_APPLICATION'))
export const useCanManageRoundsAndRequirements = () =>
  useAppSelector((state) => hasPermission(state, 'MANAGE_COLLEGE_APPLICATION_ROUNDS'))
export const useCanViewApplicants = () => useAppSelector((state) => hasPermission(state, 'VIEW_APPLICANTS'))
export const useScid = () => useAppSelector(selectUserScid)
export const useFirstName = () => useAppSelector(selectUserFirstName)
export const useLastName = () => useAppSelector(selectUserLastName)
export const useEmail = () => useAppSelector(selectEmail)
